import UserService from "@/services/UserService";
export default () => {
    return UserService.getUser()?.contractAccepted == false;
};
